import { create } from "zustand";
import { PartyState, UserState, UserType } from "@/app/store";

export interface UserStore {
	readonly userState: UserState;
	readonly partyHost: boolean;
	setUserState: (user: UserState) => void;
	setPartyHost: (partyState: PartyState) => void;
	getUserState: () => UserState;
	getUserType: () => UserType;
	isPartyHost: () => boolean;
}

export const useUserStore = create<UserStore>((set, get) => {
	return {
		userState: {
			type: "anonymous"
		},
		partyHost: false,

		setUserState: (userState: UserState): void => {
			set({ userState });
		},

		getUserType: (): UserType => {
			const userState = get().userState;

			return userState ? userState.type : "anonymous";
		},

		getUserState: (): UserState => {
			return get().userState;
		},

		setPartyHost: (partyState: PartyState): void => {
			const { userState } = get();
			const userEmail =
				userState.type !== "anonymous" ? userState.email : undefined;
			const partyHostEmail =
				partyState.status === "connected"
					? partyState.host?.emailAddress
					: undefined;
			const isHost =
				!!userEmail && !!partyHostEmail && userEmail === partyHostEmail;
			set({ partyHost: isHost });
		},

		isPartyHost: (): boolean => {
			return get().partyHost;
		}
	};
});
